// if you're using a bundler, first import:
import Headroom from "headroom.js";

const HeaderScroll = () => {
    // grab an element
    var myElement = document.querySelector("header");
    // construct an instance of Headroom, passing the element
    var headroom  = new Headroom(myElement);
    // initialise
    headroom.init();


    // Stop scroll on mobile menu open
    const headerButton = document.querySelector('.header__mobile');
    const body = document.querySelector('body');

    if (typeof headerButton != "undefined" && headerButton != null) {
        headerButton.addEventListener('click', () => {
            if (body.classList.contains('no-scroll')) {
                body.classList.remove('no-scroll');
            } else {
                body.classList.add('no-scroll');
            }
        });
    }
}

export default HeaderScroll;
